import React, { useState, useEffect } from 'react'
import { ModelsComponent } from 'components/index.js'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { useRouter } from 'next/router'

function ExploreModels() {
  const router = useRouter()
  const { query } = router
  const [activeFilter, setActiveFilter] = useState(query?.search || 'Top')

  // Handle URL query changes
  useEffect(() => {
    if (query?.search && query.search !== activeFilter) {
      setActiveFilter(query.search)
    }
  }, [query?.search])

  // Handle filter changes and update URL
  const handleFilterChange = (newFilter) => {
    setActiveFilter(newFilter)

    // Update URL query without page reload
    const newQuery = { ...query }
    if (newFilter && newFilter !== 'Top') {
      newQuery.search = newFilter
    } else {
      delete newQuery.search
    }

    router.push(
      {
        pathname: router.pathname,
        query: newQuery,
      },
      undefined,
      { shallow: true }
    )
  }

  return (
    <div className="explore-models p-2 pt-4 ">
      <ModelsComponent
        filter={activeFilter}
        onFilterChange={handleFilterChange}
        explorePage
        sortClassNames={'absolute right-5'}
      />
    </div>
  )
}

export default ExploreModels

export const getStaticProps = async ({ locale }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale ?? 'en', ['common'])),
    },
  }
}
